import { createContext } from '@lit/context';
export const scrollContext = createContext(Symbol('scrollContext'));
//# sourceMappingURL=scroll-context.js.map